module.exports = __webpack_public_path__ + "img/dockerplex.16103786.webp";